const Alerts = ()=>{
    return <div>Alerts Page</div>
}
export default Alerts